import { defineNuxtPlugin } from '#imports'
import { initRedirectUrl } from '@b2ag/redirect-url'
import { productApiClient } from '@b2ag/product/src/dependency-injection'

export default defineNuxtPlugin({
  name: 'redirect url',
  enforce: 'pre',
  parallel: true,
  setup() {
    initRedirectUrl(productApiClient)
  },
})
